import { SxProps } from '@mui/material';
import { yellow } from '@mui/material/colors';
import { greenDefault, greenHover, yellow3, yellowDefault, yellowHover } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '12px 16px',
  // background: 'transparent',

  [theme.breakpoints.down('sm')]: {
    p: '8px !important',
  },
};
export const inputsBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#ffffff',
  width: '100%',
  mt: '28px',
  borderRadius: '8px',
  boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
  p: '32px',
  gap: '32px',
};

export const addUserBtn: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: yellow,
  width: '100%',
  height: '60px',
  justifyContent: 'center',
  gap: '12px',
  marginTop: '32px',
  '&:hover': { background: yellow3 },
  '& .MuiSvgIcon-root': {
    width: '22px',
    height: '22px',
  },
};

export const sendBtn: SxProps = {
  backgroundColor: 'rgba(0, 119, 214, 1)',
  height: '41px',
  '&:hover': {
    backgroundColor: 'rgba(0, 102, 185, 1)',
  },
  fontSize: '13px',
  color: 'white',
  lineHeight: '1',
  fontWeight: 600,
  display: 'flex',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
  p: '12px 16px',
  borderRadius: '6px',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const statusPayment = (status?: number) => {
  return {
    borderRadius: '80px',
    height: '32px',
    p: '0px 16px !important',
    display: 'flex',
    gap: '8px',
    backgroundColor: status === 2 ? greenDefault : status === 3 ? yellowDefault : null,
    '&:hover': { backgroundColor: status === 2 ? greenHover : status === 3 ? yellowHover : null },
    [theme.breakpoints.down('sm')]: {
      p: '8px !important',
    },
  };
};
